import { ChangeDetectorRef, Component, Inject, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-dialog-component',
  imports: [MatDialogModule],
  templateUrl: './error-dialog-component.html',
  styleUrl: './error-dialog-component.scss',
})
export class ErrorDialogComponent implements OnInit
{
  private dialogHandle = inject(MatDialogRef<ErrorDialogComponent>);
  private cdr = inject(ChangeDetectorRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorDialogData)
  {

  }

  ngOnInit(): void
  {
    this.cdr.detectChanges();
  }

  onCancel()
  {
    this.dialogHandle.close();
  }
}

export interface ErrorDialogData
{
    severity: 'error' | 'info';
    message: string;
}

